module.exports = __webpack_public_path__ + "img/bg_grid.dc843bff.svg";